import { motion } from "framer-motion";
import { LogoMark } from "./Logo";
import { EASE } from "./scroll";

export const Seal = () => (
  <motion.div
    className="absolute right-8 top-28 z-10 hidden h-36 w-36 xl:block lg:right-14 lg:top-32 lg:h-44 lg:w-44"
    initial={{ opacity: 0, scale: 0.6, rotate: -40 }}
    animate={{ opacity: 1, scale: 1, rotate: 0 }}
    transition={{ delay: 1.4, duration: 1.4, ease: EASE }}
    aria-hidden="true"
  >
    <svg viewBox="0 0 200 200" className="seal-spin h-full w-full">
      <defs>
        <path id="seal-circle" d="M100,100 m-78,0 a78,78 0 1,1 156,0 a78,78 0 1,1 -156,0" />
      </defs>
      <circle cx="100" cy="100" r="98" fill="rgba(11,15,23,0.55)" stroke="rgba(255,255,255,0.18)" />
      <text fill="#F8FAFC" fontSize="13" fontWeight="700" fontFamily="Plus Jakarta Sans, sans-serif">
        <textPath href="#seal-circle" textLength="486" lengthAdjust="spacing">MEISTERBETRIEB · SEIT 2008 · SCHIFFERSTADT ·</textPath>
      </text>
    </svg>
    <div className="absolute inset-0 grid place-items-center">
      <LogoMark className="h-12 w-12 lg:h-14 lg:w-14" />
    </div>
  </motion.div>
);
